import { useCallback, useEffect, useRef } from "react";

export function useAnimationFrame<T>(callback: (value: T) => void) {
  const frameRef = useRef<number | undefined>(undefined);

  const animate = useCallback(
    (value: T) => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }

      frameRef.current = requestAnimationFrame(() => {
        callback(value);
      });
    },
    [callback],
  );

  useEffect(() => {
    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, []);

  return animate;
}
